/**
 * Model
 */
class Model {

	constructor() {

		var unauthHandler = function(result) { console.warn(result); }
		var errorHandler = function(result) { console.error(result); }

		/*
		 * Listeners
		 */

		$(document).on(Model.RETRIEVE_CART, function(_event) {
			console.info("Retrieving cart...");
			var fetch = new Fetch();
			fetch.get(
				"/cart.js",
				"application/json",
				function(result) {
					console.info("Cart retrieved.");
					$(document).trigger(Model.CART_RETRIEVED, [result.data]);
				},
				unauthHandler,
				errorHandler
			);
		});

		$(document).on(Model.UPDATE_CART, function(_event, formData, callback) {
			console.info("Updating cart...");
			var fetchData = new Object();
			fetchData.method = "POST";
			fetchData.body = formData;
			var fetch = new Fetch();
			fetch.execute(
				"/cart/add.js",
				fetchData,
				"application/json",
				function(result) {
					console.info("Cart updated.");
					$(document).trigger(Model.CART_UPDATED, [result.data]);
					callback(result.data);
				},
				unauthHandler,
				errorHandler
			);
		});

		$(document).on(Model.UPDATE_CART_QUANTITY, function(_event, data) {
			console.info("Updating cart quantity...");
			var fetch = new Fetch();
			fetch.post(
				"/cart/change.js",
				data,
				function(result) {
					console.info("Cart quantity updated.");
					$(document).trigger(Model.CART_QUANTITY_UPDATED, [result.data]);
				},
				unauthHandler,
				errorHandler
			);
		});

		$(document).on(Model.RETRIEVE_SECTION, function(_event, sectionName, page) {
			console.info("Retrieving section...");
			var fetch = new Fetch();
			fetch.get(
				"/collections/all?section_id=" + encodeURIComponent(sectionName) + "&page=" + encodeURIComponent(page),
				"text/html",
				function(result) {
					console.info("Section retrieved.");
					$(document).trigger(Model.SECTION_RETRIEVED, [sectionName, result.data]);
				},
				unauthHandler,
				errorHandler
			);
		})

	}

}

// ajax

Model.RETRIEVE_CART = "RETRIEVE_CART";
Model.CART_RETRIEVED = "CART_RETRIEVED";
Model.UPDATE_CART = "UPDATE_CART";
Model.CART_UPDATED = "CART_UPDATED";
Model.UPDATE_CART_QUANTITY = "UPDATE_CART_QUANTITY";
Model.CART_QUANTITY_UPDATED = "CART_QUANTITY_UPDATED";

Model.RETRIEVE_SECTION = "RETRIEVE_SECTION";
Model.SECTION_RETRIEVED = "SECTION_RETRIEVED";

// view

Model.SHOWING_CART = "SHOWING_CART";
Model.POST_MESSAGE = "POST_MESSAGE";

// variables (set from shopify settings)

Model.CURRENCY_SYMBOL = null;
Model.CURRENCY_CODE = null;
Model.TOAST_DISPLAY_DURATION = null;

// utilities

Model.formatMoney = function(amount, withSymbol) {
	var formatted = (amount / 100).toFixed(2);
	if (withSymbol != null && withSymbol == true) { formatted = Model.CURRENCY_SYMBOL + formatted; }
	return formatted;
}

// instantiate the model

new Model();

/* SAMPLE GRAPHQL - STOREFRONT API */
/*
curl -X POST \
  https://ueberschwarz.myshopify.com/api/2022-04/graphql.json \
  -H 'Content-Type: application/graphql' \
  -H 'X-Shopify-Storefront-Access-Token: 0080ff692d522dfa0995368aea0d3044' \
  -d '
  {
    products(first: 1, after: null) {
      edges {
        node {
          id
          title
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  '
*/
